import { useEffect } from 'react';
import { BASE_ROUTES } from 'core/common/constants';
import { useConfig, useServices, useUrlLocation } from 'core/common/hooks';
import { redirectToUrl } from 'core/common/utils/redirectToUrl';

export const MoneyBackPolicy = () => {
  const config = useConfig();
  const { analyticsService } = useServices();
  const { previousLocation } = useUrlLocation();

  useEffect(() => {
    analyticsService.techPageOpened(BASE_ROUTES.TECH_REFUND_POLICY, previousLocation);
    redirectToUrl(config.techLinks.moneyBackPolicy);
  }, [config.techLinks.moneyBackPolicy, analyticsService, previousLocation]);

  return null;
};
